<template>
  <div class="pagination-content">
    <el-pagination
      v-bind="$attrs"
      v-on="$listeners"
      background
      layout="total, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "xkw-pagination",
};
</script>

<style lang="scss" scoped>
.pagination-content {
  background-color: #fff;
  padding: 10px;
  text-align: right;
}
</style>
